import UppyImageCompressor from "uppy-plugin-image-compressor";
import Compressor from "compressorjs";

const ImageCompressor = UppyImageCompressor;

function compress(blob: Blob) {
	return new Promise((resolve, reject) => {
		if (blob.size > 250000) {
			// Compress only if image size greater than 250KB
			new Compressor(blob, {
				quality: blob.size < 5000000 ? 0.8 : 0.6,
				success: (result: Blob): void => {
					resolve(result);
				},
				error: (err: Error): void => {
					reject(err);
				}
			});
		} else {
			resolve(blob);
		}
	});
}

ImageCompressor.prototype.compress = compress;

export default ImageCompressor;
